var config = {};
export {
  config as __exports
};
//# sourceMappingURL=config.js.map
